module.exports = __webpack_public_path__ + "static/media/normalDealerTemp.f531fbcd.xlsx";